export default {
  title: 'Prodotti più venduti',
  columns: {
    name: 'Nome',
    quantity: 'Quantità',
    amount: 'Importo',
  },
};
